import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./homepage-analytics-moved-modal.module.css";

export const HomepageAnalyticsMovedModal = memo(
  function HomepageAnalyticsMovedModal({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    return (
      <RedoModal
        modalSize="sm"
        onModalCloseRequested={handleDismiss}
        primaryButton={{ text: "Got it", onClick: handleComplete, size: "sm" }}
        title="Homepage analytics update"
      >
        <Flex dir="column" gap="lg">
          <img
            alt="Homepage analytics update"
            className={styles.gif}
            src="https://assets.getredo.com/homeanalytics.gif"
          />
          <Text fontSize="sm" textColor="secondary">
            Homepage analytics have moved to their dedicated sections, and Order
            Tracking is now under Marketing in the sidebar.
          </Text>
        </Flex>
      </RedoModal>
    );
  },
);
